import React from "react";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Shop } from "@/components/Shop";
import { Manifesto } from "@/components/Manifesto";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

export default function Home() {
  return (
    <div className="relative">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Shop />
        <Manifesto />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
